module.exports = __webpack_public_path__ + "static/media/993794.f5a87035.png";